import React from "react";
import ReactDOM from "react-dom";
import styled, { keyframes } from "styled-components";
import { useTranslation } from "react-i18next";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0);   }
`;

const ToastContainer = styled.div`
  position: fixed;
  bottom: 2rem;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
  z-index: 9000;
`;

const ToastWrapper = styled.div`
  background: #323232;
  color: #fff;
  padding: 0.6rem 1.4rem;
  border-radius: 24px;
  font-size: 0.9rem;
  animation: ${fadeInUp} 0.25s ease;
  white-space: nowrap;
`;

type Props = {
  visible: boolean;
  message?: string;
};

export default function CopiedToast({ visible, message }: Props) {
  const { t } = useTranslation();
  if (!visible) return null;
  return ReactDOM.createPortal(
    <ToastContainer>
      <ToastWrapper>
        ✓ {message ?? t("Odkaz na trasu bol skopírovaný!")}
      </ToastWrapper>
    </ToastContainer>,
    document.body,
  );
}

CopiedToast.defaultProps = {
  message: undefined,
};
